
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7azCD", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");



/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.10.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2023
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $kyRHQ === 'object' && $kyRHQ.versions && $kyRHQ.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("h1hUh"));
        var Buffer = (parcelRequire("h1hUh")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});

parcelRegister("f7lNm", function(module, exports) {
const $ea70aa10be5defa1$export$82b05c69aac5d0c6 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ea70aa10be5defa1$export$e7d7da8c94dcb6fc = 'https://support.atlassian.com/confluence-cloud/docs/use-atlassian-intelligence-to-search-for-answers/';
const $ea70aa10be5defa1$export$506bad4598ef877f = 'https://www.atlassian.com/software/artificial-intelligence';
const $ea70aa10be5defa1$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ea70aa10be5defa1$export$b4efff19add55eb6 = 'https://confluence.atlassian.com/support/atlassian-support-ai-chat-1455423797.html';
const $ea70aa10be5defa1$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $ea70aa10be5defa1$export$d3a50b0660f215e0 = 'https://support.atlassian.com/organization-administration/docs/usage-limits-in-atlassian-intelligence/';
const $ea70aa10be5defa1$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $ea70aa10be5defa1$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $ea70aa10be5defa1$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $ea70aa10be5defa1$export$c4fda24479ad6357 = '82633dea-7fbf-4faa-9a51-a83a3fd181d9';
const $ea70aa10be5defa1$export$91d63889268b5e23 = "365\xa05ce1d-16b8-4630-9e93-6c39069625fa";
const $ea70aa10be5defa1$export$c0ced37cfe138d3e = '10f4daa4-bcfc-4d42-ae33-92888648d9db';
const $ea70aa10be5defa1$export$d04cd98bb7625919 = 'customfield_10047';
const $ea70aa10be5defa1$export$ed78826c06dd24e3 = 'fabric-elements';
var $ea70aa10be5defa1$export$83c8d7110915321e = /*#__PURE__*/ function(SOURCE) {
    SOURCE["SEARCH_DIALOG"] = "searchDialog";
    SOURCE["ADVANCED_SEARCH"] = "advancedSearch";
    SOURCE["READING_AIDS"] = "readingAids";
    return SOURCE;
}({});
const $ea70aa10be5defa1$export$e7862e8dbda0aa3 = '500px';
const $ea70aa10be5defa1$export$169d09d6d83f61d6 = '/gateway/api/smartAnswers/stream';
const $ea70aa10be5defa1$export$a00f71e6c6b44441 = '/gateway/api/assist';
const $ea70aa10be5defa1$export$cc4a4ed360fef1ba = '/gateway/api/graphql';
var $ea70aa10be5defa1$export$83d4ba88ba80625b = /*#__PURE__*/ function(QueryIntent) {
    QueryIntent["DEFAULT"] = "DEFAULT";
    QueryIntent["NATURAL_LANGUAGE_QUERY"] = "NATURAL_LANGUAGE_QUERY";
    QueryIntent["KEYWORD_OR_ACRONYM"] = "KEYWORD_OR_ACRONYM";
    QueryIntent["PERSON"] = "PERSON";
    QueryIntent["TEAM"] = "TEAM";
    QueryIntent["NAVIGATIONAL"] = "NAVIGATIONAL";
    QueryIntent["NONE"] = "NONE";
    QueryIntent["LOCATION"] = "LOCATION";
    QueryIntent["DATE"] = "DATE";
    QueryIntent["JIRA_ISSUE"] = "JIRA_ISSUE";
    QueryIntent["TOPIC"] = "TOPIC";
    QueryIntent["JIRA_NATURAL_LANGUAGE_QUERY"] = "JIRA_NATURAL_LANGUAGE_QUERY";
    QueryIntent["AGENT"] = "AGENT";
    QueryIntent["ORG_CHART"] = "ORG_CHART";
    QueryIntent["NAV_CONTENT"] = "NAV_CONTENT";
    QueryIntent["BOOKMARK"] = "BOOKMARK";
    QueryIntent["VISUAL"] = "VISUAL";
    return QueryIntent;
}({});
var $ea70aa10be5defa1$export$a08a848abe54c31f = /*#__PURE__*/ function(AnswerCardType) {
    AnswerCardType["PERSON"] = "people";
    AnswerCardType["TEAM"] = "team";
    AnswerCardType["AGENT"] = "agent";
    AnswerCardType["DATE"] = "date";
    AnswerCardType["LOCATION"] = "location";
    AnswerCardType["TOPIC"] = "topic";
    AnswerCardType["JIRA_NATURAL_LANGUAGE_QUERY"] = "jira_nl_to_jql";
    AnswerCardType["JIRA_ISSUE"] = "jira_issue";
    AnswerCardType["NAVIGATIONAL"] = "navigational";
    AnswerCardType["NAV_CONTENT"] = "nav_content";
    AnswerCardType["NONE"] = "none";
    AnswerCardType["DEFAULT"] = "default";
    AnswerCardType["SAIN"] = "SAIN";
    AnswerCardType["DEFINITION"] = "definition";
    AnswerCardType["ORG_CHART"] = "org_chart";
    AnswerCardType["BOOKMARK_KNOWLEDGE_CARD"] = "bookmarkKnowledgeCard";
    AnswerCardType["VISUAL"] = "visual";
    return AnswerCardType;
}({});
var $ea70aa10be5defa1$export$c243a7d908564b9b = /*#__PURE__*/ function(AiExperienceName) {
    AiExperienceName["PERSON_CARD"] = "Person Card";
    AiExperienceName["TEAM_CARD"] = "Team Card";
    AiExperienceName["LOCATION_CARD"] = "Location Card";
    AiExperienceName["DATE_CARD"] = "Date Card";
    AiExperienceName["TOPIC_CARD"] = "Topic Card";
    AiExperienceName["JIRA_NATURAL_LANGUAGE_QUERY_CARD"] = "Jira Card";
    AiExperienceName["AGENT_CARD"] = "Agent Card";
    AiExperienceName["JIRA_ISSUE_CARD"] = "Jira Issue Card";
    AiExperienceName["NAVIGATIONAL"] = "Navigational";
    AiExperienceName["NONE"] = "None";
    AiExperienceName["DEFAULT"] = "Default";
    AiExperienceName["PLAIN_TEXT"] = "Plain Text";
    AiExperienceName["POPULAR_SEARCH_QUERY_CARD"] = "Popular Search Query Card";
    AiExperienceName["NAVIGATIONAL_SEARCH_RESULT_CARD"] = "Navigational Search Result Card";
    return AiExperienceName;
}({});
var $ea70aa10be5defa1$export$30e36b9f4147b88f = /*#__PURE__*/ function(CardTemplate) {
    CardTemplate["DEFAULT"] = "DEFAULT";
    CardTemplate["SMART_ANSWER"] = "SMART_ANSWER";
    CardTemplate["RIGHT_PANEL"] = "RIGHT_PANEL";
    return CardTemplate;
}({});
var $ea70aa10be5defa1$export$49069087564847a7 = /*#__PURE__*/ function(AiBrand) {
    AiBrand["ROVO"] = "ROVO";
    AiBrand["AI"] = "ATLASSIAN INTELLIGENCE";
    return AiBrand;
}({});
var $ea70aa10be5defa1$export$8375a80c95e07251 = /*#__PURE__*/ function(AIAnswerTab) {
    AIAnswerTab["AI_ANSWER"] = "AI_ANSWER";
    AIAnswerTab["SOURCES"] = "SOURCES";
    return AIAnswerTab;
}({});
const $ea70aa10be5defa1$export$98d221c2fcca6d6b = [
    "AI_ANSWER",
    "SOURCES"
];
const $ea70aa10be5defa1$export$7ecd7f1b620801eb = 'convo_ai_sain_prompt_override_hello';
const $ea70aa10be5defa1$export$fe340b7aba57733d = 'atlassian.search-dialog.ai-answer-component';
module.exports["ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK"] = $ea70aa10be5defa1$export$e7d7da8c94dcb6fc;
module.exports["ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $ea70aa10be5defa1$export$59da2b3b71a076c7;
module.exports["SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $ea70aa10be5defa1$export$b4efff19add55eb6;
module.exports["ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK"] = $ea70aa10be5defa1$export$96cc4126cdc27248;
module.exports["ATLASSIAN_AI_USAGE_LIMITS_LINK"] = $ea70aa10be5defa1$export$d3a50b0660f215e0;
module.exports["ATLASSIAN_AI_TROUBLESHOOT_LINK"] = $ea70aa10be5defa1$export$50e6b843de210064;
module.exports["ATLASSIAN_HIPAA_COMPLICANCE_LINK"] = $ea70aa10be5defa1$export$dd87179defae3659;
module.exports["ATLASSIAN_ROVO_LINK"] = $ea70aa10be5defa1$export$2c1028e1e7bf5557;
module.exports["FEEDBACK_ENTRYPOINT_ID_SAIN"] = $ea70aa10be5defa1$export$c4fda24479ad6357;
module.exports["FEEDBACK_ENTRYPOINT_ID_TOPICS"] = $ea70aa10be5defa1$export$c0ced37cfe138d3e;
module.exports["FEEDBACK_CONTEXT_CF"] = $ea70aa10be5defa1$export$d04cd98bb7625919;
module.exports["DEFAULT_GAS_CHANNEL"] = $ea70aa10be5defa1$export$ed78826c06dd24e3;
module.exports["READING_AIDS_DIALOG_WIDTH"] = $ea70aa10be5defa1$export$e7862e8dbda0aa3;
module.exports["SAIN_STREAMING_API"] = $ea70aa10be5defa1$export$169d09d6d83f61d6;
module.exports["ASSISTANCE_SERVICE_API_BASE_URL"] = $ea70aa10be5defa1$export$a00f71e6c6b44441;
module.exports["DEFAULT_GRAPHQL_ENDPOINT"] = $ea70aa10be5defa1$export$cc4a4ed360fef1ba;
module.exports["QueryIntent"] = $ea70aa10be5defa1$export$83d4ba88ba80625b;
module.exports["AnswerCardType"] = $ea70aa10be5defa1$export$a08a848abe54c31f;
module.exports["AiExperienceName"] = $ea70aa10be5defa1$export$c243a7d908564b9b;
module.exports["CardTemplate"] = $ea70aa10be5defa1$export$30e36b9f4147b88f;
module.exports["AiBrand"] = $ea70aa10be5defa1$export$49069087564847a7;
module.exports["AIAnswerTab"] = $ea70aa10be5defa1$export$8375a80c95e07251;
module.exports["aiAnswerTabsOrder"] = $ea70aa10be5defa1$export$98d221c2fcca6d6b;
module.exports["PROMPT_OVERRIDE_SESSION_KEY"] = $ea70aa10be5defa1$export$7ecd7f1b620801eb;
module.exports["SEARCH_AI_ANSWER_CACHE_KEY"] = $ea70aa10be5defa1$export$fe340b7aba57733d;

});

parcelRegister("6yuru", function(module, exports) {
function $9b992db01b095d2f$export$14ef296862e3705e({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
}
module.exports["createAtlAttributionHeader"] = $9b992db01b095d2f$export$14ef296862e3705e;

});

parcelRegister("9EFEY", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dwp40 = parcelRequire("dwp40");


var $5M6sZ = parcelRequire("5M6sZ");


var $i1ClO = parcelRequire("i1ClO");

const $f389ba2de7a9be34$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $f389ba2de7a9be34$export$1642248503fca29({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f389ba2de7a9be34$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    // Populated from HTTP response via requestService (not present on JSON body).
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        },
        reportTracingHeaders: (tracing)=>{
            Object.assign(capturedTracingHeaders, tracing);
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $dh538.fg)('kd_fe_enable_api_cache')) return (0, $i1ClO.fetchAggResponseWithCache)({
        graphQuery: graphQuery,
        variables: variables,
        operationName: operationName,
        cache: cache,
        headers: headers
    });
    const response = await (0, $dwp40.utils).requestService({
        url: url
    }, options);
    // Attach gateway trace / request IDs for downstream tracing and analytics.
    return (0, $5M6sZ.enrichAggResponseWithGatewayTracingHeaders)(response, capturedTracingHeaders);
}
module.exports["fetchAggResponse"] = $f389ba2de7a9be34$export$1642248503fca29;

});

parcelRegister("5M6sZ", function(module, exports) {
function $d0dd88187373cc96$export$547fb2fa14d5b927(response, tracingHeaders) {
    if (!tracingHeaders || Object.keys(tracingHeaders).length === 0) return response;
    return {
        ...response,
        gatewayTracingHeaders: {
            ...response.gatewayTracingHeaders,
            ...tracingHeaders
        }
    };
}
module.exports["enrichAggResponseWithGatewayTracingHeaders"] = $d0dd88187373cc96$export$547fb2fa14d5b927;

});

parcelRegister("i1ClO", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $5M6sZ = parcelRequire("5M6sZ");


var $iip0W = parcelRequire("iip0W");

const $d8368aeaca537ae2$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $d8368aeaca537ae2$export$6fe550b7d5be614c({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $d8368aeaca537ae2$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    // From HTTP response headers; merged onto the payload before cache / return.
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        },
        reportTracingHeaders: (tracing)=>{
            Object.assign(capturedTracingHeaders, tracing);
        }
    };
    let cachedResponse = (0, $iip0W.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $iip0W.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $iip0W.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $dwp40.utils).requestService({
                url: url
            }, options);
            // Attach `x-trace-id` / `atl-request-id` from the HTTP layer for tracing.
            const enriched = (0, $5M6sZ.enrichAggResponseWithGatewayTracingHeaders)(response, capturedTracingHeaders);
            (0, $iip0W.InMemCache).setData({
                key: cache.key,
                response: enriched,
                ttl: cache.ttl
            });
            resolve(enriched);
        } catch (error) {
            reject(error);
        } finally{
            (0, $iip0W.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $iip0W.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}
module.exports["fetchAggResponseWithCache"] = $d8368aeaca537ae2$export$6fe550b7d5be614c;

});

parcelRegister("iip0W", function(module, exports) {
const $72ec73b0e41d4c0a$var$DEFAULT_TTL = 300000;
class $72ec73b0e41d4c0a$export$916bab80494ce385 {
    static setData({ key: key, response: response, ttl: ttl }) {
        this.cache.set(key, {
            ttl: Date.now() + (ttl || $72ec73b0e41d4c0a$var$DEFAULT_TTL),
            response: response
        });
    }
    static getData(key) {
        return this.cache.get(key)?.response;
    }
    static isValid(key) {
        const item = this.cache.get(key);
        return Boolean(item) && Date.now() < (item?.ttl || 0);
    }
    static getInflightRequest(key) {
        return this.inFlightRequests.get(key);
    }
    static setInflightRequest({ key: key, request: request }) {
        this.inFlightRequests.set(key, request);
    }
    static removeInflightRequest(key) {
        return this.inFlightRequests.delete(key);
    }
    // only for tests
    static clearCache() {
        this.cache.clear();
        this.inFlightRequests.clear();
    }
}
$72ec73b0e41d4c0a$export$916bab80494ce385.cache = new Map();
$72ec73b0e41d4c0a$export$916bab80494ce385.inFlightRequests = new Map();
module.exports["InMemCache"] = $72ec73b0e41d4c0a$export$916bab80494ce385;

});

parcelRegister("cqFuK", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $01aV7 = parcelRequire("01aV7");

// list from https://atlassian.slack.com/archives/C08VA0N40A2/p1749172242825969?thread_ts=1749088363.059769&cid=C08VA0N40A2
const $f6cafe5dbc3bbc93$var$products1PList = [
    'Assets',
    'Atlas',
    'Confluence',
    'Atlassian Analytics',
    'Atlassian Cloud',
    'Automation for Jira',
    'Bamboo',
    'Bitbucket',
    'Compass',
    'Jira',
    'Jira Product Discovery',
    'Jira Service Management',
    'Jira Software',
    'Jira Work Management',
    'Jira Align',
    'Migration',
    'Loom',
    'Opsgenie',
    'Platform Experiences',
    'Rovo',
    'Statuspage',
    'Trello',
    'webSearch',
    'web-page',
    'Fisheye and Crucible',
    'Crowd',
    'Sourcetree',
    'Unknown',
    'Focus',
    'file-upload',
    'Advanced Roadmaps For Jira',
    'Questions for Confluence',
    'csm',
    'Dewey Support',
    'Dewey JAC Support',
    'Help Aggregator'
];
const $f6cafe5dbc3bbc93$var$noAnswerPhrases = [
    "i'm sorry",
    'i apologize',
    "couldn't find ",
    "couldn't generate",
    'provide more context',
    "don't have enough information"
];
const $f6cafe5dbc3bbc93$export$e9cf531f9f13a177 = (text)=>{
    const lowerCaseText = text.toLowerCase();
    return $f6cafe5dbc3bbc93$var$noAnswerPhrases.some((phrase)=>lowerCaseText.includes(phrase));
};
const $f6cafe5dbc3bbc93$var$getSourceProducts = (sources)=>{
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};
const $f6cafe5dbc3bbc93$var$sanitizeSources = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $f6cafe5dbc3bbc93$export$fae1292002da0b83 = (sources)=>sources.filter((source)=>source.product ? !$f6cafe5dbc3bbc93$var$products1PList.includes(source.product) && !source.product.includes('Plugin') : false);
const $f6cafe5dbc3bbc93$export$dff579a44dd3965d = new Set([
    'contentId',
    'readingAidsSessionId',
    'fieldType',
    'multipleUserResultsShown',
    'numAddtlWhoMatches',
    'isCuratedDefinition',
    'isPrecomputedDefinition',
    'editDistance',
    'bookmarkId',
    'bookmarkState',
    'dwellTime',
    'availableProducts',
    'isDescriptionEmpty',
    // from extraAPIAnalyticsAttributes
    'message_id',
    'conversational_channel_id',
    'experience_id',
    'user_id',
    // Deduplicated list of plugin names and minion IDs invoked during the AI answer generation
    'pluginsInvoked',
    // from extraAnalyticsAttributes
    'experiments',
    'featureGates',
    'isFullPageSearch',
    'has3pProducts',
    'is3pSearch',
    'mode',
    'triggeredBy',
    'referrer',
    'requestId'
]);
const $f6cafe5dbc3bbc93$export$988d4f126deef74 = (extraAttributes)=>{
    if (!(0, $dh538.fg)('kd_fe_sanitize_analytics')) return extraAttributes;
    const sanitizedAttributes = {};
    // Sanitize everything except COMMON_ALLOWED_KEYS
    for(const key in extraAttributes)if ($f6cafe5dbc3bbc93$export$dff579a44dd3965d.has(key)) sanitizedAttributes[key] = extraAttributes[key];
    else // replacing with text because the value has type `any`
    sanitizedAttributes[key] = '[sanitized]';
    return sanitizedAttributes;
};
/**
 * Keys produced by `filterCommonAttributes` (including optional and feature-gated fields). Keep in
 * sync when adding new attributes there — `SEARCH_AI_ANALYTICS_CONTEXT_ATTRIBUTE_ALLOWLIST` is
 * derived from this list plus `ALLOWED_EXTRA_ATTRIBUTES_KEYS`, `location`, and `source`.
 */ const $f6cafe5dbc3bbc93$var$FILTER_COMMON_ATTRIBUTES_OUTPUT_KEYS = [
    'searchSessionId',
    'queryHash',
    'baseQueryHash',
    'wordCount',
    'queryLength',
    'answerHash',
    'appliedFilters',
    'answerFormat',
    'answerLength',
    'answerWordCount',
    'answerCardType',
    'followUpsCount',
    'followUpsLength',
    'has3PSources',
    'sources',
    'sourceProducts',
    'apiSource',
    'brand',
    'sessionId',
    'isHello',
    'sourceProduct',
    'isReadingAids',
    'queryIntent',
    'sourcesCount',
    'sources3P',
    'sources3PCount',
    'hasSources',
    'has1PSources',
    'containsNoAnswerPhrase'
];
const $f6cafe5dbc3bbc93$export$26c187b85342c353 = new Set([
    'location',
    'source',
    ...$f6cafe5dbc3bbc93$var$FILTER_COMMON_ATTRIBUTES_OUTPUT_KEYS,
    ...$f6cafe5dbc3bbc93$export$dff579a44dd3965d
]);
const $f6cafe5dbc3bbc93$export$5e5d3678c52c4007 = (data)=>{
    const location = data.location;
    const raw = {
        ...data.attributes ?? {}
    };
    if (raw.location === undefined) raw.location = location;
    const attributes = {};
    for (const key of Object.keys(raw))if ($f6cafe5dbc3bbc93$export$26c187b85342c353.has(key)) attributes[key] = raw[key];
    return {
        attributes: attributes,
        location: location
    };
};
const $f6cafe5dbc3bbc93$export$14f72eaec5bfc1a8 = (props)=>{
    const { appliedFilters: appliedFilters, answerFormat: answerFormat, answerLength: answerLength, answerWordCount: answerWordCount, answerCardType: answerCardType, followUps: followUps, sources: sources, extraAttributes: extraAttributes, searchSessionId: searchSessionId, queryHash: queryHash, baseQueryHash: baseQueryHash, query: query, answerString: answerString, apiSource: apiSource, brand: brand, sourceProduct: sourceProduct, isReadingAids: isReadingAids, queryIntent: queryIntent, sessionId: sessionId, isHello: isHello } = props;
    const filtered3P = $f6cafe5dbc3bbc93$export$fae1292002da0b83(sources);
    return {
        searchSessionId: searchSessionId,
        queryHash: queryHash,
        baseQueryHash: baseQueryHash,
        wordCount: (query.match(/\w+/g) || []).length,
        queryLength: query.length,
        answerHash: (0, $01aV7.sha256Hash)(answerString),
        appliedFilters: appliedFilters,
        answerFormat: answerFormat,
        answerLength: answerLength,
        answerWordCount: answerWordCount,
        answerCardType: answerCardType,
        followUpsCount: followUps.length,
        followUpsLength: followUps.map((followUp)=>followUp.length),
        has3PSources: filtered3P.length > 0,
        sources: $f6cafe5dbc3bbc93$var$sanitizeSources(sources),
        sourceProducts: $f6cafe5dbc3bbc93$var$getSourceProducts(sources),
        apiSource: apiSource,
        brand: brand,
        ...sourceProduct !== undefined && {
            sourceProduct: sourceProduct
        },
        ...isReadingAids !== undefined && {
            isReadingAids: isReadingAids
        },
        ...queryIntent !== undefined && {
            queryIntent: queryIntent
        },
        ...(0, $dh538.fg)('kd_consolidate_sources_analytics') && {
            sourcesCount: sources.length,
            sources3P: $f6cafe5dbc3bbc93$var$sanitizeSources(filtered3P),
            sources3PCount: filtered3P.length
        },
        ...(0, $dh538.fg)('kd_send_no_answer_attributes') && {
            hasSources: sources.length > 0,
            has1PSources: sources.length > filtered3P.length,
            containsNoAnswerPhrase: $f6cafe5dbc3bbc93$export$e9cf531f9f13a177(answerString)
        },
        sessionId: sessionId,
        isHello: isHello,
        ...$f6cafe5dbc3bbc93$export$988d4f126deef74(extraAttributes)
    };
};
module.exports["sanitizeExtraAttributes"] = $f6cafe5dbc3bbc93$export$988d4f126deef74;
module.exports["sanitizeSearchAIAnalyticsContextData"] = $f6cafe5dbc3bbc93$export$5e5d3678c52c4007;
module.exports["filterCommonAttributes"] = $f6cafe5dbc3bbc93$export$14f72eaec5bfc1a8;

});

parcelRegister("01aV7", function(module, exports) {

var $7azCD = parcelRequire("7azCD");


var $f7lNm = parcelRequire("f7lNm");

const $2d6714779ba6d3a2$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $2d6714779ba6d3a2$export$a3b7216c107a7a1 = (sourceUrl)=>{
    let url;
    try {
        url = new URL(sourceUrl);
    } catch  {
        return undefined;
    }
    return url.hostname;
};
const $2d6714779ba6d3a2$export$8e3fc93123f96c19 = (cloudId)=>{
    return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};
const $2d6714779ba6d3a2$export$694ee0cc469a8709 = (isReadingAids, smartAnswersRoute)=>{
    if (isReadingAids) return (0, $f7lNm.AnswerCardType).DEFINITION;
    switch(smartAnswersRoute){
        case (0, $f7lNm.QueryIntent).PERSON:
            return (0, $f7lNm.AnswerCardType).PERSON;
        case (0, $f7lNm.QueryIntent).TEAM:
            return (0, $f7lNm.AnswerCardType).TEAM;
        case (0, $f7lNm.QueryIntent).AGENT:
            return (0, $f7lNm.AnswerCardType).AGENT;
        case (0, $f7lNm.QueryIntent).DATE:
            return (0, $f7lNm.AnswerCardType).DATE;
        case (0, $f7lNm.QueryIntent).LOCATION:
            return (0, $f7lNm.AnswerCardType).LOCATION;
        case (0, $f7lNm.QueryIntent).TOPIC:
            return (0, $f7lNm.AnswerCardType).TOPIC;
        case (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            return (0, $f7lNm.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY;
        case (0, $f7lNm.QueryIntent).JIRA_ISSUE:
            return (0, $f7lNm.AnswerCardType).JIRA_ISSUE;
        case (0, $f7lNm.QueryIntent).NAV_CONTENT:
            return (0, $f7lNm.AnswerCardType).NAV_CONTENT;
        case (0, $f7lNm.QueryIntent).BOOKMARK:
            return (0, $f7lNm.AnswerCardType).BOOKMARK_KNOWLEDGE_CARD;
        case (0, $f7lNm.QueryIntent).VISUAL:
            return (0, $f7lNm.AnswerCardType).VISUAL;
        case (0, $f7lNm.QueryIntent).ORG_CHART:
            return (0, $f7lNm.AnswerCardType).ORG_CHART;
        case (0, $f7lNm.QueryIntent).NAVIGATIONAL:
            return (0, $f7lNm.AnswerCardType).NAVIGATIONAL;
        case (0, $f7lNm.QueryIntent).NONE:
            return (0, $f7lNm.AnswerCardType).NONE;
        case (0, $f7lNm.QueryIntent).DEFAULT:
            return (0, $f7lNm.AnswerCardType).DEFAULT;
        case (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY:
        case (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM:
        default:
            return (0, $f7lNm.AnswerCardType).SAIN;
    }
};
module.exports["sha256Hash"] = $2d6714779ba6d3a2$export$e9131c78c1110376;
module.exports["extractUrlHostname"] = $2d6714779ba6d3a2$export$a3b7216c107a7a1;
module.exports["isHello"] = $2d6714779ba6d3a2$export$8e3fc93123f96c19;
module.exports["getAnswerCardType"] = $2d6714779ba6d3a2$export$694ee0cc469a8709;

});

parcelRegister("eVM9z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eRXI0 = parcelRequire("eRXI0");


var $7Zbm6 = parcelRequire("7Zbm6");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $5Ymlp = parcelRequire("5Ymlp");


var $xhg8G = parcelRequire("xhg8G");


var $9nZle = parcelRequire("9nZle");


var $4WiNS = parcelRequire("4WiNS");


var $3qbRZ = parcelRequire("3qbRZ");

const $e71f869528412a13$var$i18n = (0, $aXWIB.defineMessages)({
    searchAiDialogQueryPretext: {
        id: "contextual-reading-aids.search-ai-dialog.query-pretext",
        defaultMessage: "what is {queryText}?"
    }
});
const $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE = 'No matching scope for Definition';
const $e71f869528412a13$export$7111b45b195dd101 = ({ workspaceId: workspaceId, cloudIdARI: cloudIdARI, fetchConfig: fetchConfig, isDefinitionCurationEnabled: isDefinitionCurationEnabled, productConfig: productConfig, product: product })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { contentId: contentId } = productConfig;
    const fetchAIGeneratedDefinition = (0, $42omo.useCallback)(async ({ variables: variables })=>{
        const { query: query, locale: locale, additional_context: additional_context, experience: experience, followUpsEnabled: followUpsEnabled } = variables;
        if (contentId !== '') try {
            const precomputedResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $4WiNS.PrecomputedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    contentId: contentId
                },
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (precomputedResult.data && !precomputedResult.data.knowledgeDiscovery.autoDefinition.message) {
                const data = {
                    nlpSearch: {
                        ...(0, $3qbRZ.mapCustomDefinitionToNLPSearchType)(precomputedResult.data.knowledgeDiscovery.autoDefinition),
                        extraAPIAnalyticsAttributes: {
                            requestId: precomputedResult.extensions?.gateway?.trace_id ?? null
                        }
                    }
                };
                setLoading(false);
                return data;
            } else if (precomputedResult.data && precomputedResult.data.knowledgeDiscovery.autoDefinition.message) throw new Error(precomputedResult.data.knowledgeDiscovery.autoDefinition.message);
            else throw new Error('Something went wrong with fetching precomputed definition');
        } catch (error) {
            if (error instanceof Object && 'message' in error && error.message !== $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $xhg8G.fetchPrecomputedDefinitionErrorPayload)(error, commonAttributes));
        }
        const streamFetchArgs = {
            variables: {
                query: intl.formatMessage($e71f869528412a13$var$i18n.searchAiDialogQueryPretext, {
                    queryText: query
                }),
                locale: locale,
                cloudIdARI: cloudIdARI,
                additional_context: additional_context,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            },
            isReadingAids: true,
            fetchConfig: fetchConfig,
            generatorConfig: {
                yieldAnswerPart: true,
                yieldFinalResponse: true
            },
            onStreamFinalResponse: ()=>{
                setLoading(false);
            }
        };
        return {
            type: (0, $7Zbm6.AIAnswerAPIType).STREAM,
            stream: (0, $5Ymlp.aiDefinitionsStreamFetchConvoAIService)(streamFetchArgs)
        };
    }, [
        cloudIdARI,
        fetchConfig,
        intl,
        commonAttributes,
        fireAnalyticsEvent,
        workspaceId,
        contentId,
        product
    ]);
    const fetchDefinition = (0, $42omo.useCallback)(async ({ variables: variables })=>{
        if (isDefinitionCurationEnabled) try {
            let confluenceScopeId, jiraScopeId;
            if ('spaceId' in productConfig) confluenceScopeId = productConfig;
            else if ('projectId' in productConfig) jiraScopeId = {
                projectId: productConfig.projectId
            };
            const result = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $9nZle.CuratedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    confluenceScopeId: confluenceScopeId,
                    jiraScopeId: jiraScopeId
                },
                operationName: (0, $9nZle.CURATED_DEFINITION_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (result.data && !result.data.knowledgeDiscovery.definition.message) {
                const data = {
                    nlpSearch: {
                        ...(0, $3qbRZ.mapCustomDefinitionToNLPSearchType)(result.data.knowledgeDiscovery.definition),
                        extraAPIAnalyticsAttributes: {
                            requestId: result.extensions?.gateway?.trace_id ?? null
                        }
                    }
                };
                setLoading(false);
                return data;
            } else if (result.data && result.data.knowledgeDiscovery.definition.message) throw new Error(result.data.knowledgeDiscovery.definition.message);
            else throw new Error('Something went wrong with fetching curated definition');
        } catch (error) {
            // want to fire event when error.message does not equal the no curated definition message
            // returned by the query in data.knowledgeDiscovery.definition.message
            if (error instanceof Object && 'message' in error && error.message !== $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $xhg8G.fetchCuratedDefinitionErrorPayload)(error, commonAttributes));
            return fetchAIGeneratedDefinition({
                variables: variables
            });
        }
        return fetchAIGeneratedDefinition({
            variables: variables
        });
    }, [
        productConfig,
        fetchAIGeneratedDefinition,
        isDefinitionCurationEnabled,
        workspaceId,
        commonAttributes,
        fireAnalyticsEvent,
        cloudIdARI,
        product
    ]);
    return {
        fetchDefinition: fetchDefinition,
        loading: loading
    };
};
module.exports["useDefinitionSupplier"] = $e71f869528412a13$export$7111b45b195dd101;

});

parcelRegister("eRXI0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $f7lNm = parcelRequire("f7lNm");

const $c9273af68a747a43$var$UNINITIALIZED_COMMON_ATTRIBUTES = {
    cloudId: '',
    query: '',
    queryHash: '',
    baseQueryHash: '',
    source: '',
    searchSessionId: '',
    answerString: '',
    answerLength: 0,
    answerWordCount: 0,
    answerFormat: null,
    answerCardType: (0, $f7lNm.AnswerCardType).SAIN,
    sources: [],
    followUps: [],
    errorStateSuggestedQueries: [],
    errorState: null,
    extraAttributes: {},
    apiSource: 'cc-search-nlp',
    workspaceId: '',
    sessionId: '',
    brand: (0, $f7lNm.AiBrand).AI,
    orgId: '',
    isHello: false
};
const $c9273af68a747a43$export$19a05d5f6391d0e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    loading: undefined,
    isAnswered: false,
    hasError: false,
    advancedSearchUrl: undefined,
    onNavigate: ()=>{},
    updateContextCache: ()=>{},
    fireAnalyticsEvent: ()=>{},
    setQuery: ()=>{},
    setData: ()=>{},
    userDetails: {},
    disclaimer: null,
    commonAttributes: $c9273af68a747a43$var$UNINITIALIZED_COMMON_ATTRIBUTES,
    initialCollapsed: undefined,
    liked: undefined,
    setLiked: ()=>{},
    likesDisabled: false,
    setLikesDisabled: ()=>{},
    initialReported: undefined,
    isReadingAids: false,
    dynamicLayoutSubAgentMessages: [],
    setDynamicLayoutSubAgentMessages: ()=>{},
    cardProviderProps: undefined,
    baseQuery: undefined,
    smartAnswersRoute: (0, $f7lNm.QueryIntent).DEFAULT,
    cardTemplate: (0, $f7lNm.CardTemplate).DEFAULT,
    brand: (0, $f7lNm.AiBrand).AI,
    answerEditor: undefined,
    closeParentDialog: ()=>{},
    showGenericFooter: false,
    initiallyExpanded: false,
    queryIntentClassificationData: undefined,
    traceHeaders: undefined
});
const $c9273af68a747a43$export$1485bfa2a4aa8c9b = ()=>{
    return (0, $42omo.useContext)($c9273af68a747a43$export$19a05d5f6391d0e1);
};
module.exports["AIAnswerContext"] = $c9273af68a747a43$export$19a05d5f6391d0e1;
module.exports["useAIAnswerContext"] = $c9273af68a747a43$export$1485bfa2a4aa8c9b;

});

parcelRegister("5Ymlp", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $epS7s = parcelRequire("epS7s");


var $iA4lt = parcelRequire("iA4lt");


var $7Zbm6 = parcelRequire("7Zbm6");


var $4Zqgi = parcelRequire("4Zqgi");


var $f7lNm = parcelRequire("f7lNm");


var $5Wlau = parcelRequire("5Wlau");

const $6ff046935ab0156c$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
function $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids) {
    return isReadingAids ? {
        named_id: 'reading_aids_agent',
        experience: 'reading-aids'
    } : {
        named_id: 'sain_agent',
        experience: 'sain'
    };
}
function $6ff046935ab0156c$var$mapMimeTypeToFormat(mimeType) {
    switch(mimeType){
        case 'text/markdown':
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $7Zbm6.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $7Zbm6.NLPSearchResultFormat).JSON;
        default:
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
    }
}
function $6ff046935ab0156c$var$mapErrorToSain(error, traceId) {
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswer
            };
        case 'NO_ANSWER_PEOPLE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion
            };
        case 'NO_ANSWER_KEYWORDS':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords
            };
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults
            };
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation
            };
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse
            };
        case 'FEATURE_DISABLED_ON_SITE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).AIDisabled
            };
        default:
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                networkErrorReason: 'unmapped_backend_error',
                networkErrorDetails: errorMessage,
                backendFailureType: 'unmapped_template'
            };
    }
}
function $6ff046935ab0156c$var$mapMessageToNLPSearchType(message, requestId) {
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message || message;
    return {
        nlpResult: messageContent.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $6ff046935ab0156c$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($6ff046935ab0156c$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : message.message?.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $dh538.fg)('kd_consolidate_sources_analytics') && {
                sources: message.sources
            },
            cacheInfo: message.message?.message_metadata?.global_cache_info ?? null,
            pluginInvocations: message.message?.plugin_invocations,
            rawJson: message,
            ...(0, $dh538.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            }
        }
    };
}
async function* $6ff046935ab0156c$export$87d234127b4babfd({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig }) {
    try {
        const { query: query, locale: locale, experience: experience, filters: filters, cloudIdARI: cloudIdARI, followUpsEnabled: followUpsEnabled } = variables || {};
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.SAIN_STREAMING_API)}`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                filters: filters,
                locations: [
                    cloudIdARI
                ],
                locale: locale,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            }),
            credentials: fetchConfig?.credentials || 'same-origin'
        }));
        if (!response.ok) // For non 200 status codes
        return {
            state: 'failed',
            reason: 'backend',
            details: 'Unhandled error response received',
            errorCode: response.status
        };
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = JSON.parse(line);
                    if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) yield parsedData;
                    else {
                        finalResponse = parsedData;
                        done = true;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
const $6ff046935ab0156c$var$getAgentInput = ({ variables: variables, fetchConfig: fetchConfig })=>{
    const { query: query, locale: locale, additional_context: additional_context, experimentContext: experimentContext, isQuerySuggestion: isQuerySuggestion } = variables || {};
    return {
        content: query,
        locale: locale,
        additional_context: additional_context,
        entity_ari: fetchConfig?.entity_ari,
        ...experimentContext && (0, $dh538.fg)('kd_sain_backend_exp_context') && {
            experimentContext: experimentContext
        },
        ...typeof isQuerySuggestion === 'boolean' ? {
            isQuerySuggestion: isQuerySuggestion
        } : {}
    };
};
const $6ff046935ab0156c$var$getPromptOverrideContext = ()=>{
    if (!(0, $dh538.fg)('convo_ai_sain_enable_prompt_override_hello_only')) return {};
    const promptOverride = (0, $epS7s.getSessionItem)((0, $f7lNm.PROMPT_OVERRIDE_SESSION_KEY));
    if (!promptOverride) return {};
    return {
        aiFeatureContext: {
            systemPromptOverride: promptOverride
        }
    };
};
async function* $6ff046935ab0156c$export$3e1bd964ad0ba888({ fetchReturn: fetchReturn, variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, storeMessage: storeMessage, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const { filters: filters, selectedProduct: selectedProduct } = variables || {};
        const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/sain/stream`;
        const streamFilters = filters && !Array.isArray(filters) && (0, $dh538.fg)('kd_add_common_filters_support_to_sain') ? [
            {
                commonFilters: filters.commonFilters
            },
            {
                confluenceFilters: filters.confluenceFilters
            }
        ] : [
            {
                confluenceFilters: filters
            }
        ];
        if (selectedProduct) streamFilters.push({
            knowledgeSources: [
                selectedProduct
            ]
        });
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience,
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: {
                    ...$6ff046935ab0156c$var$getAgentInput({
                        variables: variables,
                        fetchConfig: fetchConfig
                    }),
                    filters: filters ? streamFilters : undefined,
                    ...$6ff046935ab0156c$var$getPromptOverrideContext()
                },
                ...storeMessage
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            backendFailureType: 'empty_body'
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            const pluginsInvoked = [];
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status,
                        backendFailureType: 'hipaa'
                    };
                    // For non 200 status codes
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status,
                        backendFailureType: 'http_error'
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $5Wlau.mapStreamSAINResponse)(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === 'plugin-invocation') {
                        pluginsInvoked.push(parsedData.pluginName);
                        continue;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop) return {
                        state: 'complete',
                        value: parsedData
                    };
                    else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            if ((0, $dh538.fg)('kd_add_plugins_invoked')) {
                const filteredPluginsInvoked = pluginsInvoked.filter(Boolean);
                if (filteredPluginsInvoked.length > 0 && finalResponse.message) {
                    const existing = finalResponse.message.extraAPIAnalyticsAttributes?.pluginsInvoked ?? [];
                    finalResponse.message.extraAPIAnalyticsAttributes = {
                        ...finalResponse.message.extraAPIAnalyticsAttributes,
                        pluginsInvoked: [
                            ...new Set([
                                ...existing,
                                ...filteredPluginsInvoked
                            ])
                        ]
                    };
                }
            }
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
async function $6ff046935ab0156c$export$c8ae4e2310d6c222({ variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig }) {
    const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
    const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/chat/v1/invoke_agent`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': 'confluence',
            'X-Experience-Id': experience,
            ...fetchConfig?.headers
        },
        body: JSON.stringify({
            recipient_agent_named_id: named_id,
            agent_input: $6ff046935ab0156c$var$getAgentInput({
                variables: variables,
                fetchConfig: fetchConfig
            })
        }),
        credentials: fetchConfig?.credentials || 'same-origin',
        signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
    });
    const traceId = response.headers.get('x-trace-id') || null;
    const data = await response.json();
    if ('message_template' in data) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $6ff046935ab0156c$var$mapErrorToSain(data, traceId);
        return {
            nlpSearch: {
                errorState: errorState,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    return {
        nlpSearch: $6ff046935ab0156c$var$mapMessageToNLPSearchType(data, traceId)
    };
}
async function* $6ff046935ab0156c$export$824b789d24de77d3({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/ai-definition`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': 'reading-aids',
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                ...$6ff046935ab0156c$var$getAgentInput({
                    variables: variables,
                    fetchConfig: fetchConfig
                })
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            backendFailureType: 'empty_body'
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status,
                        backendFailureType: 'hipaa'
                    };
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status,
                        backendFailureType: 'http_error'
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $5Wlau.mapStreamDefinitionResponse)(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
module.exports["sainStreamFetchConvoAIService"] = $6ff046935ab0156c$export$3e1bd964ad0ba888;
module.exports["aiDefinitionsStreamFetchConvoAIService"] = $6ff046935ab0156c$export$824b789d24de77d3;

});

parcelRegister("epS7s", function(module, exports) {

var $c4TO3 = parcelRequire("c4TO3");


var $dh538 = parcelRequire("dh538");

const $760a00543381114b$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $760a00543381114b$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $760a00543381114b$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $760a00543381114b$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $760a00543381114b$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $760a00543381114b$export$fdf7104ff19cc288 = (key)=>{
    const windowReady = $760a00543381114b$var$getWindow();
    if (!windowReady) return null;
    return (0, $dh538.fg)('search_page_use_bsc_session_storage') ? (0, $c4TO3.AtlBrowserStorageSession).getItem(key) : $760a00543381114b$var$getWindow()?.sessionStorage.getItem(key);
};
const $760a00543381114b$export$a5376dd4adeb0fbf = (key, value)=>{
    const windowReady = $760a00543381114b$var$getWindow();
    if (!windowReady) return;
    try {
        if ((0, $dh538.fg)('search_page_use_bsc_session_storage')) (0, $c4TO3.AtlBrowserStorageSession).setItem(key, value);
        else $760a00543381114b$var$getWindow()?.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $760a00543381114b$export$5896963da935fdc4 = (key)=>{
    const windowReady = $760a00543381114b$var$getWindow();
    if (!windowReady) return;
    if ((0, $dh538.fg)('search_page_use_bsc_session_storage')) (0, $c4TO3.AtlBrowserStorageSession).removeItem(key);
    else $760a00543381114b$var$getWindow()?.sessionStorage.removeItem(key);
};
module.exports["SEARCH_QUERY_KEY"] = $760a00543381114b$export$240cb7dc75f6cac2;
module.exports["SEARCH_FILTERS_KEY"] = $760a00543381114b$export$978fb20afa14aaa7;
module.exports["SEARCH_SHOW_AI_DIALOG_KEY"] = $760a00543381114b$export$f4dca218ecb5824a;
module.exports["getSessionItem"] = $760a00543381114b$export$fdf7104ff19cc288;
module.exports["setSessionItem"] = $760a00543381114b$export$a5376dd4adeb0fbf;
module.exports["deleteSessionItem"] = $760a00543381114b$export$5896963da935fdc4;

});

parcelRegister("iA4lt", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $4vEoF = parcelRequire("4vEoF");

const $3a954310db248169$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError })=>{
    try {
        const cohort = (0, $c6GJD.default).getExperiment(abTestId).get('cohort', (0, $4vEoF.Cohort).Default);
        const serveExperiment = cohort === (0, $4vEoF.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $4vEoF.Cohort).Default
    };
};
const $3a954310db248169$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).checkGate('search-experiment-overrides-killswitch')) return $3a954310db248169$var$defaultCheckGate;
    if (!overrides) return $3a954310db248169$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $3a954310db248169$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $3a954310db248169$var$defaultCheckGate;
    }
};
const $3a954310db248169$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).checkGate('search-experiment-overrides-killswitch')) return $3a954310db248169$export$a68238496eb1c8ce;
    if (!overrides) return $3a954310db248169$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $3a954310db248169$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $4vEoF.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $3a954310db248169$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $3a954310db248169$var$defaultCheckGate = (name)=>(0, $c6GJD.default).checkGate(name);
const $3a954310db248169$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $c6GJD.default).getLayer(layerName, options);
    return undefined;
};
module.exports["getFrontendExperiment"] = $3a954310db248169$export$a68238496eb1c8ce;
module.exports["createFeatureGateHandler"] = $3a954310db248169$export$8774a01dc80b4a26;
module.exports["createFrontendExperimentHandler"] = $3a954310db248169$export$841981a8a1feee8d;
module.exports["getMutuallyExclusiveUIExperiment"] = $3a954310db248169$export$b8cc3cdd046fba93;

});

parcelRegister("4vEoF", function(module, exports) {
var $f534e05ac776c43b$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});
module.exports["Cohort"] = $f534e05ac776c43b$export$b76685d1b5a37732;

});

parcelRegister("4Zqgi", function(module, exports) {

var $97HEP = parcelRequire("97HEP");

const $2afb97bb773ddd18$var$error = async ({ error: error, functionName: functionName, traceId: traceId })=>{
    try {
        const SentryClient = await (0, $97HEP.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('packageName', '@atlassian/search-ai');
            scope.setFingerprint([
                `functionName: ${functionName}`
            ]);
            if (traceId) scope.setTag('traceId', traceId);
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
const $2afb97bb773ddd18$export$af88d00dbe7f521 = {
    error: $2afb97bb773ddd18$var$error
};
module.exports["logger"] = $2afb97bb773ddd18$export$af88d00dbe7f521;

});

parcelRegister("97HEP", function(module, exports) {

var $3nPYZ = parcelRequire("3nPYZ");


var $1JvBr = parcelRequire("1JvBr");


var $g8CIJ = parcelRequire("g8CIJ");

let $effdb799a148a720$var$Sentry;
const $effdb799a148a720$var$beforeSend = (event)=>{
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    if (event.environment === 'development') return null;
    return event;
};

const $effdb799a148a720$export$f553e8b08ef59d31 = async ()=>{
    if (!$effdb799a148a720$var$Sentry) $effdb799a148a720$var$Sentry = (parcelRequire("6jYyB")).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $g8CIJ.SENTRY_DSN),
            attachStacktrace: true,
            release: (0, $3nPYZ.PRODUCT_BUILD) || (0, $g8CIJ.UNKNOWN_TAG),
            environment: (0, $1JvBr.getEnvironment)(),
            beforeSend: $effdb799a148a720$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $effdb799a148a720$var$Sentry;
};
module.exports["getSentryClient"] = $effdb799a148a720$export$f553e8b08ef59d31;

});

parcelRegister("3nPYZ", function(module, exports) {
// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 *  - For the service workers where window is not available, we return 'unknown'.
 */ const $caff51da97cfcbcc$export$668f31ea3127f48f = (typeof window !== 'undefined' && (window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION)) ?? 'unknown';
module.exports["PRODUCT_BUILD"] = $caff51da97cfcbcc$export$668f31ea3127f48f;

});

parcelRegister("1JvBr", function(module, exports) {
const $bfee5be0414bd1fa$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $bfee5be0414bd1fa$export$57570b1603cf6adb;

});

parcelRegister("g8CIJ", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/afm-search-ai/getting-started/
const $6ddb4d99fe6d7477$export$6faa4a850bc4d0ce = 'https://467ed23c400f1de490da05364bed5930@o55978.ingest.us.sentry.io/4507432686125056';
const $6ddb4d99fe6d7477$export$ea77880e3935182d = 'unknown';
module.exports["SENTRY_DSN"] = $6ddb4d99fe6d7477$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $6ddb4d99fe6d7477$export$ea77880e3935182d;

});

parcelRegister("6jYyB", function(module, exports) {

let $49a37dcba4f239e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49a37dcba4f239e3$var$load("h3ABO"),
    $49a37dcba4f239e3$var$load("kC80R")
]).then(()=>parcelRequire('7hGsm'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("5Wlau", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7Zbm6 = parcelRequire("7Zbm6");


var $4Zqgi = parcelRequire("4Zqgi");


var $59vy4 = parcelRequire("59vy4");


var $2NVuz = parcelRequire("2NVuz");

const $087142bc218bc052$var$mapMimeTypeToFormat = (mimeType)=>{
    switch(mimeType){
        case 'text/markdown':
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $7Zbm6.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $7Zbm6.NLPSearchResultFormat).JSON;
        default:
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
    }
};
const $087142bc218bc052$var$mapErrorTo = (error, traceId)=>{
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswer
            };
        case 'NO_ANSWER_PEOPLE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion
            };
        case 'NO_ANSWER_KEYWORDS':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords
            };
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults
            };
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation
            };
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse
            };
        case 'FEATURE_DISABLED_ON_SITE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).AIDisabled
            };
        default:
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                networkErrorReason: 'unmapped_backend_error',
                networkErrorDetails: errorMessage,
                backendFailureType: 'unmapped_template'
            };
    }
};
const $087142bc218bc052$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
const $087142bc218bc052$export$b4465cb8e5734ca9 = (message, requestId)=>{
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message;
    // The CSM streaming endpoint puts sources inside SAINMessage (message.message.sources)
    // rather than at the SAINAgentResponse level (message.sources). Fall back to the
    // nested location so citations and the Sources section render correctly for both the APIs.
    const sources = message.sources ?? message.message?.sources;
    return {
        nlpResult: (0, $dh538.fg)('kd_sain_extract_footnote') ? $087142bc218bc052$export$231abbb3de9b00b5(messageContent.content) : messageContent.content,
        uniqueSources: sources ? sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $087142bc218bc052$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($087142bc218bc052$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : messageContent.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $dh538.fg)('kd_consolidate_sources_analytics') && {
                sources: sources
            },
            cacheInfo: messageContent.message_metadata?.global_cache_info ?? null,
            pluginInvocations: messageContent.plugin_invocations,
            rawJson: message,
            ...(0, $dh538.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            },
            ...(0, $dh538.fg)('kd_add_plugins_invoked') && (()=>{
                const pluginNames = (messageContent.plugin_invocations ?? []).map((p)=>p.plugin_name).filter(Boolean);
                const minionOutputs = messageContent.minion_outputs ?? [];
                const minionIds = minionOutputs.flat().map((m)=>m.minion_id).filter(Boolean);
                const pluginsInvoked = [
                    ...pluginNames,
                    ...minionIds
                ];
                return pluginsInvoked.length > 0 ? {
                    pluginsInvoked: pluginsInvoked
                } : {};
            })()
        }
    };
};
const $087142bc218bc052$export$ed070f749797478 = (response, traceId)=>{
    if ((0, $2NVuz.isStreamError)(response)) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $087142bc218bc052$var$mapErrorTo(response, traceId);
        return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
            message: {
                errorState: errorState,
                errorCode: response.message.status_code,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    if ((0, $2NVuz.isStreamGenerationType)(response) && (0, $59vy4.SAINFeatureControl).canRenderLumina()) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType,
        message: {
            answer_generation_type: response.message.answer_generation_type
        }
    };
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamSAINResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $087142bc218bc052$export$b4465cb8e5734ca9(response.message, traceId)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    if ((0, $2NVuz.isStreamErrorStateQuerySuggestions)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions,
        suggested_queries: response.message.suggested_queries ?? []
    };
    if ((0, $59vy4.SAINFeatureControl).canRenderLumina()) {
        if ((0, $2NVuz.isStreamDynamicLayoutSubAgent)(response)) return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage,
            message: response.message
        };
    }
    if ((0, $dh538.fg)('kd_sain_early_stop_hello_exp_fg') || (0, $dh538.fg)('kd_sain_early_stop_customer_exp_fg')) {
        if ((0, $2NVuz.isStreamEarlyStop)(response)) {
            const earlyStopSearchResult = {
                nlpResult: response.message?.reason ?? '',
                format: null,
                uniqueSources: [],
                errorState: (0, $7Zbm6.NLPSearchErrorState).EarlyStop,
                disclaimer: null
            };
            return {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop,
                message: earlyStopSearchResult
            };
        }
    }
    if (response.type === 'PLUGIN_INVOCATION' && response.message?.plugin_name) return {
        type: 'plugin-invocation',
        pluginName: response.message.plugin_name
    };
    return {
        type: 'other'
    };
};
const $087142bc218bc052$export$b4d3daa122c7e257 = (message, traceId)=>{
    return {
        nlpResult: message.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
        extraAPIAnalyticsAttributes: {
            requestId: traceId ?? null,
            userQuery: message.human_message?.content ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $dh538.fg)('kd_consolidate_sources_analytics') && {
                sources: message.sources
            },
            rawJson: message
        }
    };
};
const $087142bc218bc052$export$fb9e9bea38ae660f = (response, traceId)=>{
    if ((0, $2NVuz.isStreamError)(response)) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $087142bc218bc052$var$mapErrorTo(response, traceId);
        return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
            message: {
                errorState: errorState,
                errorCode: response.message.status_code,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamDefinitionResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $087142bc218bc052$export$b4d3daa122c7e257(response.message, traceId)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
};
const $087142bc218bc052$export$231abbb3de9b00b5 = (result)=>{
    const removeFootnoteRegex = /\[\^(\d{1,2})\^\]:\s*https?:\/\/.*$/gm;
    const removeNonDigitCitationsRegex = /\[\^([a-zA-Z\-]+)\^\]/g;
    let cleanedAnswer = result.replace(removeFootnoteRegex, '').trim();
    cleanedAnswer = cleanedAnswer.replace(removeNonDigitCitationsRegex, '').trim();
    return cleanedAnswer;
};
module.exports["mapStreamSAINResponse"] = $087142bc218bc052$export$ed070f749797478;
module.exports["mapStreamDefinitionResponse"] = $087142bc218bc052$export$fb9e9bea38ae660f;

});

parcelRegister("59vy4", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $4OGlb = parcelRequire("4OGlb");


var $eUEtI = parcelRequire("eUEtI");

const $38536d7307700a9c$var$canRenderLuminaUnmemoized = ()=>{
    if ((0, $dh538.fg)('kd_dynamic_layout_in_sain')) return true;
    return false;
};
const $38536d7307700a9c$var$isBorderlessUXEnabledUnmemoized = ()=>{
    if ((0, $eUEtI.hasSAINHelloLayerParamValue)('LuminaInSAIN', 'test')) return true;
    if ((0, $eUEtI.hasSAINLayerParamValue)('LuminaInSAIN', 'test')) return true;
    return false;
};
const $38536d7307700a9c$var$isSAINUXUpliftEnabledUnmemoized = ()=>{
    const helloLayer = (0, $c6GJD.default).getLayer((0, $eUEtI.SAIN_HELLO_LAYER_NAME));
    const helloCustomersEnabled = helloLayer.get('isSainUXUpliftEnabled', false);
    const customerLayer = (0, $c6GJD.default).getLayer((0, $eUEtI.SAIN_LAYER_NAME));
    const customersEnabled = customerLayer.get('isSainUXUpliftEnabled', false);
    if (helloCustomersEnabled || customersEnabled) return true;
    return false;
};
const $38536d7307700a9c$var$isSourcesInShortSAINAnswersEnabledUnmemoized = ()=>{
    if ((0, $dh538.fg)('kd_sain_show_sources_in_short_answers')) return true;
    return (0, $eUEtI.hasSAINLayerParamValue)('sourcesInShortSAINAnswers', 'test');
};
const $38536d7307700a9c$var$isZeroQuerySuggestionsV1EnabledUnmemoized = (isHello)=>{
    if (isHello) return true;
    const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_ROVO_SEARCH_QF_EXPERIENCE_LAYER));
    const customersEnabled = layer.get('isZeroQuerySuggestionsV1Enabled', false);
    return customersEnabled;
};
const $38536d7307700a9c$var$isSourcesSidePanelEnabledUnmemoized = ()=>{
    if ((0, $eUEtI.hasSAINHelloLayerParamValue)('SAINSourcesUplift', 'SourcesInSidePanel')) return true;
    if ((0, $eUEtI.hasSAINLayerParamValue)('SAINSourcesUplift', 'SourcesInSidePanel')) return true;
    return false;
};
const $38536d7307700a9c$var$isSourcesFullWidthEnabledUnmemoized = ()=>{
    if ((0, $eUEtI.hasSAINHelloLayerParamValue)('SAINSourcesUplift', 'FullWidthSAIN')) return true;
    if ((0, $eUEtI.hasSAINLayerParamValue)('SAINSourcesUplift', 'FullWidthSAIN')) return true;
    return false;
};
const $38536d7307700a9c$var$isFullHeightLuminaEnabledUnmemoized = ()=>{
    if ((0, $dh538.fg)('kd_enable_full_height_lumina')) return true;
    return false;
};
const $38536d7307700a9c$var$isNonPrimaryClickTrackingEnabledUnmemoized = ()=>{
    if ((0, $dh538.fg)('kd_track_non_primary_clicks_gate')) return true;
    if ((0, $c6GJD.default).getExperimentValue('kd_track_non_primary_clicks', 'shouldTrackNonPrimaryClicks', 'control', {
        fireExperimentExposure: false
    }) === 'test') return true;
    return false;
};
const $38536d7307700a9c$var$triggerNonPrimaryClickTrackingExposure = ()=>{
    try {
        if (!(0, $dh538.fg)('kd_track_non_primary_clicks_gate')) (0, $c6GJD.default).manuallyLogExperimentExposure('kd_track_non_primary_clicks');
    } catch  {
    // Silently fail if FeatureGates is not available (e.g., in test environments)
    }
};
const $38536d7307700a9c$var$isJiraSAINCardSmartLinkEnabledUnmemoized = ({ sourceProduct: sourceProduct })=>{
    const { serveExperiment: serveJiraFPSNLQNavigationExperiment } = (0, $eUEtI.getJiraUIExperienceLayerFrontendExperiment)({
        abTestId: 'rovo_jira_nin_fps_nlq_navigation_exp'
    });
    const { serveExperiment: serveJiraFPSNLQNavigationTenantsExperiment } = (0, $eUEtI.getJiraUIExperienceTenantsLayerFrontendExperiment)({
        abTestId: 'rovo_jira_nin_fps_nlq_navigation_tenants_exp'
    });
    return sourceProduct === 'jira' && ((0, $dh538.fg)('kd_jira_sain_card_smartlink_fg') || serveJiraFPSNLQNavigationExperiment || serveJiraFPSNLQNavigationTenantsExperiment);
};
const $38536d7307700a9c$export$1f65635c37e1bde3 = {
    /** Controls whether frontend can parse and render lumina-formatted answers */ canRenderLumina: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$canRenderLuminaUnmemoized),
    /** Controls the borderless UX experiment (visual design refresh) */ isBorderlessUXEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isBorderlessUXEnabledUnmemoized),
    isSAINUXUpliftEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isSAINUXUpliftEnabledUnmemoized),
    isSourcesSidePanelEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isSourcesSidePanelEnabledUnmemoized),
    isSourcesFullWidthEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isSourcesFullWidthEnabledUnmemoized),
    isFullHeightLuminaEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isFullHeightLuminaEnabledUnmemoized),
    isSourcesInShortSAINAnswersEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isSourcesInShortSAINAnswersEnabledUnmemoized),
    isZeroQuerySuggestionsV1Enabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isZeroQuerySuggestionsV1EnabledUnmemoized),
    isNonPrimaryClickTrackingEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isNonPrimaryClickTrackingEnabledUnmemoized),
    triggerNonPrimaryClickTrackingExposure: $38536d7307700a9c$var$triggerNonPrimaryClickTrackingExposure,
    isJiraSAINCardSmartLinkEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isJiraSAINCardSmartLinkEnabledUnmemoized)
};
module.exports["SAINFeatureControl"] = $38536d7307700a9c$export$1f65635c37e1bde3;

});

parcelRegister("4OGlb", function(module, exports) {
const $8c848bb8ca35d190$export$71a8b319599e57dc = 'l1_premium_vs_standard';
const $8c848bb8ca35d190$export$c076c4dd9e9d1e6e = 'search_platform_layer_l1_standard';
const $8c848bb8ca35d190$export$23877616cb34cf0c = 'search_platform_layer_l1_premium';
const $8c848bb8ca35d190$export$68be56e20dba0ed5 = 'l2_premium_vs_standard';
const $8c848bb8ca35d190$export$f39fa5cd744578ae = 'search_platform_layer_l2_standard';
const $8c848bb8ca35d190$export$a36d8c2d9981ec2b = 'search_platform_layer_l2_premium';
const $8c848bb8ca35d190$export$fe025e19388affcf = 'search_platform_layer_l2_blending';
const $8c848bb8ca35d190$export$11e2cd4e8edc5e82 = 'search_platform_layer_l3';
const $8c848bb8ca35d190$export$9b30fb0a29b39382 = 'search_platform_layer_query_expansion';
const $8c848bb8ca35d190$export$a62089c95934ccf8 = 'enable_l3';
const $8c848bb8ca35d190$export$4e36729d15b3db9e = 'enable_query_rewrite';
const $8c848bb8ca35d190$export$87f92c12fc8bb620 = 'search_platform_non_overlapping_domain';
const $8c848bb8ca35d190$export$86bb6d2503529310 = 'search_platform_layer_l1';
const $8c848bb8ca35d190$export$722a4624bef605fa = 'search_platform_layer_l2';
const $8c848bb8ca35d190$export$1963cf4be1b2cd5e = 'search_platform_layer_l3';
const $8c848bb8ca35d190$export$a18b3b3caa760214 = 'search_platform_layer_query_expansion';
const $8c848bb8ca35d190$export$39bbb550e0341d58 = 'full_page_search_layer';
const $8c848bb8ca35d190$export$b669e8e4ed2b4c67 = 'quick_find_layer';
const $8c848bb8ca35d190$export$ee35a7247cdafe84 = 'search_platform_jira_layer';
const $8c848bb8ca35d190$export$2d33b7f91c9f9071 = 'search_platform_jira_layer_tenants_based';
const $8c848bb8ca35d190$export$dd8503a49fbff14d = 'rovo_search_qf_experience_layer';
const $8c848bb8ca35d190$export$afc3cbf9db978004 = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    controlId: 'default',
    abTestId: 'default'
};
const $8c848bb8ca35d190$export$fca208e1e43c6fac = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    experimentLayers: []
};
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM"] = $8c848bb8ca35d190$export$71a8b319599e57dc;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD"] = $8c848bb8ca35d190$export$c076c4dd9e9d1e6e;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM"] = $8c848bb8ca35d190$export$23877616cb34cf0c;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM"] = $8c848bb8ca35d190$export$68be56e20dba0ed5;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD"] = $8c848bb8ca35d190$export$f39fa5cd744578ae;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM"] = $8c848bb8ca35d190$export$a36d8c2d9981ec2b;
module.exports["STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER"] = $8c848bb8ca35d190$export$fe025e19388affcf;
module.exports["STATSIG_SEARCH_BACKEND_L3_LAYER"] = $8c848bb8ca35d190$export$11e2cd4e8edc5e82;
module.exports["STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER"] = $8c848bb8ca35d190$export$9b30fb0a29b39382;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED"] = $8c848bb8ca35d190$export$a62089c95934ccf8;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED"] = $8c848bb8ca35d190$export$4e36729d15b3db9e;
module.exports["STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN"] = $8c848bb8ca35d190$export$87f92c12fc8bb620;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_NAME"] = $8c848bb8ca35d190$export$86bb6d2503529310;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_NAME"] = $8c848bb8ca35d190$export$722a4624bef605fa;
module.exports["STATSIG_SEARCH_BACKEND_L3_LAYER_NAME"] = $8c848bb8ca35d190$export$1963cf4be1b2cd5e;
module.exports["STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME"] = $8c848bb8ca35d190$export$a18b3b3caa760214;
module.exports["STATSIG_FULL_PAGE_SEARCH_LAYER"] = $8c848bb8ca35d190$export$39bbb550e0341d58;
module.exports["STATSIG_QUICK_FIND_LAYER"] = $8c848bb8ca35d190$export$b669e8e4ed2b4c67;
module.exports["STATSIG_SEARCH_PLATFORM_JIRA_LAYER"] = $8c848bb8ca35d190$export$ee35a7247cdafe84;
module.exports["STATSIG_SEARCH_PLATFORM_JIRA_LAYER_TENANTS_BASED"] = $8c848bb8ca35d190$export$2d33b7f91c9f9071;
module.exports["STATSIG_ROVO_SEARCH_QF_EXPERIENCE_LAYER"] = $8c848bb8ca35d190$export$dd8503a49fbff14d;
module.exports["DEFAULT_STATSIG_EXPERIMENT_CONFIG"] = $8c848bb8ca35d190$export$afc3cbf9db978004;
module.exports["DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG"] = $8c848bb8ca35d190$export$fca208e1e43c6fac;

});

parcelRegister("eUEtI", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $c6GJD = parcelRequire("c6GJD");


var $4OGlb = parcelRequire("4OGlb");


var $iA4lt = parcelRequire("iA4lt");


var $4Zqgi = parcelRequire("4Zqgi");

const $ff35af2675612b0e$export$5091efb9b1abe9af = 'kd_sain_layer';
const $ff35af2675612b0e$export$61cd502eadfc7f4a = 'kd_sain_hello_layer';
const $ff35af2675612b0e$export$fb4dba971e54444f = 'rovo_jira_ui_experience_layer';
const $ff35af2675612b0e$export$50eae6f311ab1b36 = 'rovo_jira_ui_tenants_experience_layer';
function $ff35af2675612b0e$export$c5e2c0a7fe245f7d() {
    const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), {
        fireLayerExposure: false
    });
    const abTestId = layer.get('abTestId', 'no_ab_test_id');
    if (abTestId === 'kd_disable_sain_experiment') {
        const backendExperimentData = layer.get('backendChanges', {
            sain: true
        });
        if (!backendExperimentData?.sain) return true;
    }
    return false;
}
function $ff35af2675612b0e$var$doesLayerFrontendExperimentExist(layerName, abTestId) {
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const layerFrontendExperimentName = layer.get('frontendExperimentName', null);
    return layerFrontendExperimentName !== null && layerFrontendExperimentName === abTestId;
}
function $ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({ layerName: layerName, abTestId: abTestId, onError: onError }) {
    const falseEvaluationResult = {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: 'not-enrolled'
    };
    const handleError = (error)=>{
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: `getLayerFrontendExperimentUnmemoized(${layerName})`
        });
        onError?.(error);
    };
    try {
        // we skip experiment evaluation if the user is part of the SAIN holdback experiment test cohort,
        // because SAIN is disabled in this case
        if ($ff35af2675612b0e$export$c5e2c0a7fe245f7d()) return falseEvaluationResult;
        if ($ff35af2675612b0e$var$doesLayerFrontendExperimentExist(layerName, abTestId)) return (0, $iA4lt.getFrontendExperiment)({
            abTestId: abTestId,
            onError: handleError
        });
    } catch (error) {
        handleError(error);
    }
    return falseEvaluationResult;
}
const $ff35af2675612b0e$export$3de2a2aa2c11f251 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$5091efb9b1abe9af
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$5c2fc79d2a515e54 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$61cd502eadfc7f4a
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$2ae87375886cb5b0 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$fb4dba971e54444f
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$399aed7d323465a6 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$50eae6f311ab1b36
    }), ({ abTestId: abTestId })=>abTestId);
function $ff35af2675612b0e$var$getLayerFrontendMultiArmExperimentUnmemoized({ layerName: layerName, abTestId: abTestId, onError: onError }) {
    const handleError = (error)=>{
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: `getLayerFrontendExperimentUnmemoized(${layerName})`
        });
        onError?.(error);
    };
    try {
        // we skip experiment evaluation if the user is part of the SAIN holdback experiment test cohort,
        // because SAIN is disabled in this case
        if (!$ff35af2675612b0e$export$c5e2c0a7fe245f7d() && $ff35af2675612b0e$var$doesLayerFrontendExperimentExist(layerName, abTestId)) {
            const experiment = (0, $c6GJD.default).getExperiment(abTestId);
            const cohort = experiment.get('cohort', 'not-enrolled');
            return {
                abTestId: abTestId,
                cohort: cohort
            };
        }
    } catch (error) {
        handleError(error);
    }
    return {
        abTestId: abTestId,
        cohort: 'not-enrolled'
    };
}
const $ff35af2675612b0e$export$3e4672526d3420fc = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$5091efb9b1abe9af
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$7ea065ff36b2919b = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$61cd502eadfc7f4a
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$ef7d89c571d837a1 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((paramName)=>{
    const layer = (0, $c6GJD.default).getLayer($ff35af2675612b0e$export$5091efb9b1abe9af);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $ff35af2675612b0e$export$98e9af5151f46651 = (paramName, paramValue)=>{
    return $ff35af2675612b0e$export$ef7d89c571d837a1(paramName) === paramValue;
};
const $ff35af2675612b0e$export$2a3e1ea63f6e0a96 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((paramName)=>{
    const layer = (0, $c6GJD.default).getLayer($ff35af2675612b0e$export$61cd502eadfc7f4a);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $ff35af2675612b0e$export$acf5b4af6876c34 = (paramName, paramValue)=>{
    return $ff35af2675612b0e$export$2a3e1ea63f6e0a96(paramName) === paramValue;
};
module.exports["SAIN_LAYER_NAME"] = $ff35af2675612b0e$export$5091efb9b1abe9af;
module.exports["SAIN_HELLO_LAYER_NAME"] = $ff35af2675612b0e$export$61cd502eadfc7f4a;
module.exports["getSAINLayerFrontendExperiment"] = $ff35af2675612b0e$export$3de2a2aa2c11f251;
module.exports["getJiraUIExperienceLayerFrontendExperiment"] = $ff35af2675612b0e$export$2ae87375886cb5b0;
module.exports["getJiraUIExperienceTenantsLayerFrontendExperiment"] = $ff35af2675612b0e$export$399aed7d323465a6;
module.exports["hasSAINLayerParamValue"] = $ff35af2675612b0e$export$98e9af5151f46651;
module.exports["hasSAINHelloLayerParamValue"] = $ff35af2675612b0e$export$acf5b4af6876c34;

});

parcelRegister("2NVuz", function(module, exports) {
/** Types copied from platform/packages/ai-mate/conversation-assistant/src/services/assistance-service/types.ts for now */ var $605e1a783968ada3$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $605e1a783968ada3$export$255ec938a30a2b3 = /*#__PURE__*/ function(StreamAnswerGenerationTypes) {
    StreamAnswerGenerationTypes["LUMINA"] = "LUMINA";
    StreamAnswerGenerationTypes["STANDARD"] = "STANDARD";
    return StreamAnswerGenerationTypes;
}({});
const $605e1a783968ada3$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $605e1a783968ada3$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $605e1a783968ada3$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $605e1a783968ada3$export$c563bc6129a38894 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $605e1a783968ada3$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
const $605e1a783968ada3$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $605e1a783968ada3$export$cfb6b6bb809f778e = (message)=>message instanceof Object && message.type === 'FOLLOW_UP_QUERIES';
const $605e1a783968ada3$export$de29cc71fd2aafc1 = (message)=>message instanceof Object && message.type === 'ERROR_STATE_QUERY_SUGGESTIONS';
const $605e1a783968ada3$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $605e1a783968ada3$export$b6b59db8d0b45219 = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $605e1a783968ada3$export$1598409b78d1d369 = (message)=>message instanceof Object && message.type === 'EARLY_STOP';
const $605e1a783968ada3$export$53e95dec5f877b4e = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
module.exports["StreamAnswerGenerationTypes"] = $605e1a783968ada3$export$255ec938a30a2b3;
module.exports["isStreamError"] = $605e1a783968ada3$export$d422a2733a3b5def;
module.exports["isStreamAnswerPart"] = $605e1a783968ada3$export$e45102edbc73b240;
module.exports["isStreamGenerationType"] = $605e1a783968ada3$export$c563bc6129a38894;
module.exports["isStreamTrace"] = $605e1a783968ada3$export$fd5a05be03f147a0;
module.exports["isStreamFollowUp"] = $605e1a783968ada3$export$cfb6b6bb809f778e;
module.exports["isStreamErrorStateQuerySuggestions"] = $605e1a783968ada3$export$de29cc71fd2aafc1;
module.exports["isStreamDynamicLayoutSubAgent"] = $605e1a783968ada3$export$5fa02529cd2ab34c;
module.exports["isStreamSAINResponse"] = $605e1a783968ada3$export$b6b59db8d0b45219;
module.exports["isStreamEarlyStop"] = $605e1a783968ada3$export$1598409b78d1d369;
module.exports["isStreamDefinitionResponse"] = $605e1a783968ada3$export$53e95dec5f877b4e;

});

parcelRegister("xhg8G", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");

const $d691b863678f8843$export$1b6ec2a437dbf65e = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$b3c6d7a1ecb4efe1 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiPrecomputedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$ef8b7cdd9a33efb4 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionUpdate',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$48200d71a3e25afe = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiDefinitionToggle',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
module.exports["fetchCuratedDefinitionErrorPayload"] = $d691b863678f8843$export$1b6ec2a437dbf65e;
module.exports["fetchPrecomputedDefinitionErrorPayload"] = $d691b863678f8843$export$b3c6d7a1ecb4efe1;
module.exports["updateDefinitionErrorPayload"] = $d691b863678f8843$export$ef8b7cdd9a33efb4;
module.exports["toggleDefinitionErrorPayload"] = $d691b863678f8843$export$48200d71a3e25afe;

});

parcelRegister("9nZle", function(module, exports) {
// query to check whether curated definition exists
const $797cf255205c2458$export$9051e5c888508a3d = 'CuratedDefinitionQuery';
const $797cf255205c2458$export$1886f34f107a0451 = `
query ${$797cf255205c2458$export$9051e5c888508a3d}(
		$workspaceId: String!
		$keyPhrase: String!
		$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
		$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
	) {
		knowledgeDiscovery {
			definition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				confluenceScopeId: $confluenceScopeId
				jiraScopeId: $jiraScopeId
			) @optIn(to: "KnowledgeDiscovery Get definition") {
				__typename
				... on KnowledgeDiscoveryDefinition {
					definition
					accountId
					createdAt
					editor {
						... on User {
							name
							accountId
						}
					}
					referenceUrl
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["CURATED_DEFINITION_OPERATION_NAME"] = $797cf255205c2458$export$9051e5c888508a3d;
module.exports["CuratedDefinitionQuery"] = $797cf255205c2458$export$1886f34f107a0451;

});

parcelRegister("4WiNS", function(module, exports) {
const $205ce4d60dc88166$export$73cd67d787c37f2e = `
query PrecomputedDefinitionQuery(
		$workspaceId: String!
		$keyPhrase: String!
        $contentId: String!
	) {
		knowledgeDiscovery {
			autoDefinition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				contentId: $contentId
			) @optIn(to: "KnowledgeDiscovery Get auto definition") {
				__typename
				... on KnowledgeDiscoveryAutoDefinition {
					definition
                    createdAt
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
					}
				}
				... on QueryError {
					message
                    extensions {
                        statusCode
                        errorType
                    }
				}
			}
		}
	}
`;
module.exports["PrecomputedDefinitionQuery"] = $205ce4d60dc88166$export$73cd67d787c37f2e;

});

parcelRegister("3qbRZ", function(module, exports) {

var $7Zbm6 = parcelRequire("7Zbm6");

const $9a638390fddaeddf$export$faaccabd846a199 = (definition)=>{
    const definitionReference = definition.confluenceEntity;
    return {
        nlpResult: definition.definition,
        uniqueSources: definitionReference ? [
            {
                id: definitionReference?.id || '',
                title: definitionReference?.title || '',
                url: 'referenceUrl' in definition ? definition.referenceUrl || '' : 'links' in definitionReference && definitionReference.links.base && definitionReference.links.webUi ? `${definitionReference.links.base}${definitionReference.links.webUi}` : '',
                type: definitionReference?.type || '',
                // Currently curated and precomputed definitions sources can only be Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: 'editor' in definition ? {
            name: definition.editor?.name || '',
            id: definition.editor?.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
        customDefinitionType: 'editor' in definition ? (0, $7Zbm6.NLPSearchCustomDefinitionType).CURATED : (0, $7Zbm6.NLPSearchCustomDefinitionType).PRECOMPUTED
    };
};
module.exports["mapCustomDefinitionToNLPSearchType"] = $9a638390fddaeddf$export$faaccabd846a199;

});

parcelRegister("7wVkn", function(module, exports) {
/* definition-popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lGgRw = parcelRequire("lGgRw");

const $7a4b02046260f338$var$popupContainerStyles = null;
const $7a4b02046260f338$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1pbyowjs"
        ]),
        children: children
    });
});
const $7a4b02046260f338$var$definitionPopupTriggerStylesStatic = null;

const $7a4b02046260f338$var$LazyDefinitionPopupContent = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iOSie")).then((module)=>({
            default: module.DefinitionPopupContent
        })));
function $7a4b02046260f338$export$576a6d4c65a0c923({ onClose: onClose, triggerPosition: triggerPosition, onLoad: onLoad, ...definitionPopupContentProps }) {
    const definitionPopupTriggerStylesDynamic = {
        height: `${triggerPosition.height}px`,
        left: `${triggerPosition.left}px`,
        top: `${triggerPosition.top}px`,
        width: `${triggerPosition.width}px`
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        content: ({ update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)($7a4b02046260f338$var$LazyDefinitionPopupContent, {
                    ...definitionPopupContentProps,
                    onClose: onClose,
                    onLoad: ()=>{
                        onLoad?.();
                        update();
                    }
                })
            }),
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: $7a4b02046260f338$var$CustomPopupContainer,
        testId: "definition-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                ...triggerProps,
                style: definitionPopupTriggerStylesDynamic,
                "data-testid": "definition-popup-trigger",
                className: (0, $gMc0m.default)([
                    "_tzy4idpf _kqswstnw _lcxvglyw _bfhk1j28 _1ltvidpf _94n5idpf"
                ])
            }),
        isOpen: true
    });
}
module.exports["DefinitionPopup"] = $7a4b02046260f338$export$576a6d4c65a0c923;

});

parcelRegister("iOSie", function(module, exports) {

let $db3702f7ffc34741$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db3702f7ffc34741$var$load("h3ABO"),
    $db3702f7ffc34741$var$load("9hYRW"),
    $db3702f7ffc34741$var$load("kpm7S"),
    $db3702f7ffc34741$var$load("kc8tx"),
    $db3702f7ffc34741$var$load("2YffH"),
    $db3702f7ffc34741$var$load("g7ggm"),
    $db3702f7ffc34741$var$load("6mHrv"),
    $db3702f7ffc34741$var$load("awWN9"),
    $db3702f7ffc34741$var$load("9CYct"),
    $db3702f7ffc34741$var$load("5lCAe"),
    $db3702f7ffc34741$var$load("dvaCT"),
    $db3702f7ffc34741$var$load("dLE56"),
    $db3702f7ffc34741$var$load("hZtKG"),
    $db3702f7ffc34741$var$load("dkqvW"),
    $db3702f7ffc34741$var$load("lVO3w"),
    $db3702f7ffc34741$var$load("hyzoX"),
    $db3702f7ffc34741$var$load("h9Ed7"),
    $db3702f7ffc34741$var$load("eBRUf"),
    $db3702f7ffc34741$var$load("kbRvk"),
    $db3702f7ffc34741$var$load("tKhaz"),
    $db3702f7ffc34741$var$load("hwT9D"),
    $db3702f7ffc34741$var$load("j4Bpe"),
    $db3702f7ffc34741$var$load("cD6Zr"),
    $db3702f7ffc34741$var$load("fPSgL"),
    $db3702f7ffc34741$var$load("8nbmv"),
    $db3702f7ffc34741$var$load("k3jER"),
    $db3702f7ffc34741$var$load("9wzNh"),
    $db3702f7ffc34741$var$load("8YSo7"),
    $db3702f7ffc34741$var$load("9ldRJ"),
    $db3702f7ffc34741$var$load("9anPW"),
    $db3702f7ffc34741$var$load("50ame"),
    $db3702f7ffc34741$var$load("7do1E"),
    $db3702f7ffc34741$var$load("77dkW"),
    $db3702f7ffc34741$var$load("1MlIV"),
    $db3702f7ffc34741$var$load("6iz6l"),
    $db3702f7ffc34741$var$load("4SCW2"),
    $db3702f7ffc34741$var$load("aXHNO"),
    $db3702f7ffc34741$var$load("kmvek"),
    $db3702f7ffc34741$var$load("Wowvf"),
    $db3702f7ffc34741$var$load("421lv"),
    $db3702f7ffc34741$var$load("dYtBN"),
    $db3702f7ffc34741$var$load("6wr18"),
    $db3702f7ffc34741$var$load("kjZZD"),
    $db3702f7ffc34741$var$load("7cDV0"),
    $db3702f7ffc34741$var$load("ijD5W"),
    $db3702f7ffc34741$var$load("3JSgG"),
    $db3702f7ffc34741$var$load("37ldp"),
    $db3702f7ffc34741$var$load("ffEVr"),
    $db3702f7ffc34741$var$load("9AXkC"),
    $db3702f7ffc34741$var$load("28arV"),
    $db3702f7ffc34741$var$load("hhss7"),
    $db3702f7ffc34741$var$load("hvsDR"),
    $db3702f7ffc34741$var$load("9t4BV"),
    $db3702f7ffc34741$var$load("f1Pmi"),
    $db3702f7ffc34741$var$load("hogcU"),
    $db3702f7ffc34741$var$load("2Stk7"),
    $db3702f7ffc34741$var$load("7EorR"),
    $db3702f7ffc34741$var$load("77ceh")
]).then(()=>parcelRequire('bA47i'));

});

parcelRegister("9KkVf", function(module, exports) {
var $3b7655b6bdb7bdb0$export$a53c998f5fa685e1 = /*#__PURE__*/ function(EditedDefinitionScope) {
    EditedDefinitionScope["SPACE"] = "SPACE";
    EditedDefinitionScope["PAGE"] = "PAGE";
    EditedDefinitionScope["BLOGPOST"] = "BLOGPOST";
    EditedDefinitionScope["ORGANIZATION"] = "ORGANIZATION";
    EditedDefinitionScope["PROJECT"] = "PROJECT";
    return EditedDefinitionScope;
}({});
module.exports["EditedDefinitionScope"] = $3b7655b6bdb7bdb0$export$a53c998f5fa685e1;

});

parcelRegister("97Szk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $chO1Z = parcelRequire("chO1Z");


var $gXn1S = parcelRequire("gXn1S");


var $ctmPb = parcelRequire("ctmPb");


var $9RVmI = parcelRequire("9RVmI");


var $9KkVf = parcelRequire("9KkVf");

const $3fda69966c9a64cd$var$i18n = (0, $aXWIB.defineMessages)({
    editDefinitionRestrictedToSpaceOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.space.option",
        defaultMessage: "In this space"
    },
    editDefinitionRestrictedToPageOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.page.option",
        defaultMessage: "On this page"
    },
    editDefinitionRestrictedToBlogpostOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.blogpost.option",
        defaultMessage: "On this blogpost"
    },
    editDefinitionRestrictedToSiteOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.site.option",
        defaultMessage: "On this site"
    }
});
function $3fda69966c9a64cd$export$ad09b24d617a41f5(contentType) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return (0, $42omo.useMemo)(()=>[
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSpaceOption),
                value: (0, $9KkVf.EditedDefinitionScope).SPACE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                    label: ""
                })
            },
            contentType === 'blogpost' ? {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToBlogpostOption),
                value: (0, $9KkVf.EditedDefinitionScope).BLOGPOST,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                    label: ""
                })
            } : {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToPageOption),
                value: (0, $9KkVf.EditedDefinitionScope).PAGE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
                    label: ""
                })
            },
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSiteOption),
                value: (0, $9KkVf.EditedDefinitionScope).ORGANIZATION,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ctmPb))), {
                    label: ""
                })
            }
        ], [
        contentType,
        formatMessage
    ]);
}
module.exports["useDefinitionRestrictionOptions"] = $3fda69966c9a64cd$export$ad09b24d617a41f5;

});


//# sourceMappingURL=sha256SimpleHasher.15c04d7b.js.map
